import React from "react";
import { useTranslation } from "react-i18next"; 

function CountryBanner({country}) {
  const { t } = useTranslation();
  // convert country name like "Serbia" → translation key "country.serbia"
  const countryKey = `country:${country?.toLowerCase().replace(/\s+/g, "-")}`;
  const translatedCountry = t(countryKey, country); // fallback to original if not found
  
  return (
    <section className="country-banner">
      {/* <div className="banner-details" style={{ backgroundImage: `url(/images/jpg/${country?.toLowerCase().replace(/ /g, "-")}.jpg` }}> */}
      <div className="banner-details">
        <div className="align-items-center justify-content-between gap-1 position-relative">
          <h2 className="f-s-36 f-w-400">
            {/* {country} */}
            {translatedCountry}
          </h2>
          {country=== 'Kosovo' && (
          <div style={{fontSize: "14px",color: "#9d9999"}} >
            {/* *Ова назив је без прејудицирања статуса и у складу је са резолуцијом Савета Безбедности УН 1244/1999 и мишљењем Међународног суда правде о Декларацији о независности Косова. */}

            * {t("home:countries:kosovo-tooltip","This designation is without prejudice to positions on status and is in line with UNSCR 1244/1999 and the ICJ Opinion on the Kosovo Declaration of Independence.") }
          </div>
          )}
          {/* <div>
            <img src={`/images/jpg/${country?.toLowerCase().replace(/ /g, "-")}-map.jpg`} className="img-fluid" alt="" />
          </div> */}
        </div>
      </div>
      <p>
        {t("country:country-banner:description","The Roma strategy is designed to enhance social inclusion and improve living conditions for the Roma community, which has historically faced discrimination and marginalization. The primary goals of the strategy include increasing access to quality education, healthcare, and employment opportunities while also fostering an environment that promotes cultural heritage and identity. Key focus areas involve developing targeted educational programs to reduce dropout rates, implementing healthcare initiatives to address the specific needs of the Roma population, and creating job training and employment opportunities. Additionally, the strategy emphasizes the importance of legal protection against discrimination and encourages community engagement in local governance processes to empower the Roma community.")}       
      </p>
    </section>
  );
}

export default CountryBanner;
